import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PaymentList from './PaymentList';

const Payments = () => {
  return (
    <Routes>
      <Route path="/" element={<PaymentList />} />
      <Route path="*" element={<Navigate to="/payments" replace />} />
    </Routes>
  );
};

export default Payments;
